import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Drawer,
    Input,
    Table,
    Select,
    Form,
    Radio,
    Col,
    Row,
} from 'antd';
import { userManagement_roles_ActionHandler } from '../../../../../Redux/Actions/user/UserManagementRoles';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import { workspaces_User_Create_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesUserCreate';
import { workspace_roles_Permission_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceRolePermissionList';
import axios from 'axios';
const Option = { Select };
const CreateUser = ({ AddCreditsOverlay, isAddCreditsOpen }) => {
    let dispatch = useDispatch();
    const info6 = '/assets/info-6.svg';
    const SideClose = '/assets/ModalClose.svg';
    const [workSpaceAccess, setWorkSpaceAccess] = useState([]);
    const [workSpaceRoleAccess, setWorkSpaceRoleAccess] = useState([]);

    const [workspace, setWorkSpace] = useState([]);
    const userManagementRoles = useSelector(
        (state) => state?.userManagement_Roles_Data?.userManagement_roles_data
    );
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspacesRolesList = useSelector(
        (state) =>
            state?.Workspace_Role_Permission_Roles_list_Data
                ?.workspace_roles_list_data
    );
    const handleRadioChange = (workspace_role_id, workspace_id) => {
        if (workspace_role_id !== 0) {
            const workspace_object = {
                workspace_id: workspace_id,
                workspace_role_id: workspace_role_id,
            };
            const updatedWorkspace = workspace.filter(
                (item) => item.workspace_id !== workspace_id
            );
            const workspaceArray = [...updatedWorkspace, workspace_object];
            setWorkSpace(workspaceArray);
        } else {
            const updatedWorkspace = workspace.filter(
                (item) => item.workspace_id !== workspace_id
            );
            const workspaceArray = [...updatedWorkspace];
            setWorkSpace(workspaceArray);
        }
    };
    const workspaceAccesscolumns = [
        {
            title: 'workSpace Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            fixed: 'left',
        },
        {
            title: 'Access',
            dataIndex: 'access',
            key: 'access',
            render: (text, option) => {
                return (
                    <>
                        <Row justify='start'>
                            <Radio.Group
                                className={`workspaceaccess-useraccess`}
                                style={{ width: 'max-content' }}>
                                <Radio
                                    onChange={() =>
                                        handleRadioChange(0, option.id)
                                    }
                                    className={`workspaceaccess-useraccess-checkbox`}
                                    name='workspace_role_id'
                                    value={0}>
                                    No Access
                                </Radio>
                                {workSpaceRoleAccess.map((record) => (
                                    <Radio
                                        onChange={() =>
                                            handleRadioChange(
                                                record.id,
                                                option.id
                                            )
                                        }
                                        className={`workspaceaccess-useraccess-checkbox`}
                                        name='workspace_role_id'
                                        value={record.id}>
                                        {record.name}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Row>
                    </>
                );
            },
        },
    ];
    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        dispatch(workspace_roles_Permission_ActionHandler());
    }, []);
    useEffect(() => {
        if (workspaceData) {
            setWorkSpaceAccess(workspaceData);
        }
    }, [workspaceData]);
    useEffect(() => {
        if (workspacesRolesList) {
            setWorkSpaceRoleAccess(workspacesRolesList.data.roles);
        }
    }, [workspacesRolesList]);

    useEffect(() => {
        dispatch(userManagement_roles_ActionHandler());
    }, [dispatch]);
    const onFinish = (values) => {
        const updateValue = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            role_id: values.role_id,
            access_to_workspace_ids: workspace,
        };
        dispatch(workspaces_User_Create_ActionHandler(updateValue));
        setTimeout(() => {
            AddCreditsOverlay();
        }, 2000);
    };

    return (
        <Drawer
            placement='right'
            closable={false}
            onClose={AddCreditsOverlay}
            open={isAddCreditsOpen}
            key='right'
            width={'40%'}>
            <img
                className='usermanagement-sideClose'
                src={SideClose}
                alt=''
                onClick={AddCreditsOverlay}
            />
            <div className='side-modal-div'>
                <h3>Create User</h3>
            </div>
            <Form
                name='uploadComputerForm'
                onFinish={onFinish}
                initialValues={{
                    first_name: '',
                    last_name: '',
                    email: '',
                    role_id: '',
                }}>
                <div className='usermanagement-input'>
                    <div className='usermanagement-1'>
                        <label>First name</label>
                        <Form.Item
                            name='first_name'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your First Name!',
                                },
                                {
                                    type: 'first_name',
                                    message: 'Please enter a valid First Name',
                                },
                            ]}>
                            <Input placeholder='Enter your First Name' />
                        </Form.Item>
                    </div>
                    <div className='usermanagement-1'>
                        <label>Last name</label>
                        <Form.Item
                            name='last_name'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Last Name!',
                                },
                                {
                                    type: 'last_name',
                                    message: 'Please enter a valid Last Name',
                                },
                            ]}>
                            <Input placeholder='Enter your Last Name' />
                        </Form.Item>
                    </div>
                    <div className='usermanagement-1'>
                        <label>Email ID</label>
                        <Form.Item
                            name='email'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Email ID!',
                                },
                                {
                                    type: 'email',
                                    message: 'Please enter a valid Email ID',
                                },
                            ]}>
                            <Input placeholder='Enter your Email ID' />
                        </Form.Item>
                    </div>
                    <div className='usermanagement-2'>
                        <label>Select Role</label>
                        <Form.Item
                            name='role_id'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select a role!',
                                },
                            ]}>
                            <Select className='usermanagement-workspace-select'>
                                {userManagementRoles?.data?.length > 0 &&
                                    userManagementRoles?.data?.map(
                                        (option, index) => (
                                            <option
                                                key={index}
                                                value={option.id}>
                                                {option.name}
                                            </option>
                                        )
                                    )}
                            </Select>
                        </Form.Item>
                    </div>
                    <div className='usermanagement-1'>
                        <label>Select workspace access</label>
                        <div className='workspace-access-mt-15'>
                            <Table
                                columns={workspaceAccesscolumns}
                                dataSource={workSpaceAccess}
                                bordered
                                size='middle'
                                pagination={false}
                                className='mytable'
                                scroll={{
                                    x: 1500,
                                }}
                            />
                        </div>
                    </div>
                    <div className='usermanagement-4'>
                        <label>
                            <img src={info6} alt='info6' /> Default password
                            will be generated for this user and shared with them
                            via email.
                        </label>
                    </div>
                    <div className='usermanagement-3'>
                        <Form.Item>
                            <Button
                                type='primary'
                                htmlType='submit'
                                block
                                className='usermanagement-save'>
                                Save
                            </Button>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </Drawer>
    );
};
export default CreateUser;
